import Vue from 'vue'
import Router from 'vue-router'

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};//解决router重复路由报错
Vue.use(Router)
let router = new Router({
  // mode: 'history',//去掉#号
  routes: [
    {
      path: '/',
      redirect: '/home',
      components: {
        default: () => import('../views/index.vue')
      },
      children: [
        {
          path: '/home',
          name: 'home',
          components: {
            default: () => import('../views/home.vue')
          },
        },
        {
          path: '/film',
          name: 'film',
          components: {
            default: () => import('../views/film.vue')
          },
        },
        {
          path: '/film_detail/:id',
          name: 'film',
          components: {
            default: () => import('../views/film_detail.vue')
          },
        },
        {
          path: '/artist',
          name: 'artist',
          components: {
            default: () => import('../views/artist.vue')
          },
        },
        {
          path: '/artist_detail/:id',
          name: 'artist_detail',
          components: {
            default: () => import('../views/artist_detail.vue')
          },
        },
        {
          path: '/training',
          name: 'training',
          components: {
            default: () => import('../views/training.vue')
          },
        },
        {
          path: '/ImagesFinishing',
          name: 'ImagesFinishing',
          components: {
            default: () => import('../views/ImagesFinishing.vue')
          },
        },
        {
          path: '/images',
          name: 'images',
          components: {
            default: () => import('../views/images.vue')
          },
        },
        {
          path: '/searchResult',
          name: 'searchResult',
          components: {
            default: () => import('../views/searchResult.vue')
          },
        },
        {
          path: '/images_detail/:id',
          name: 'images_detail',
          components: {
            default: () => import('../views/images_detail.vue')
          },
        },
        {
          path: '/contribute',
          name: 'contribute',
          components: {
            default: () => import('../views/contribute.vue')
          },
        },
        {
          path: '/outputImage',
          name: 'outputImage',
          components: {
            default: () => import('../views/outputImage.vue')
          },
        },
        {
          path: '/Picture',
          name: 'Picture',
          components: {
            default: () => import('../views/Picture.vue')
          },
        },
        {
          path: '/moreHonor',
          name: 'moreHonor',
          components: {
            default: () => import('../views/moreHonor.vue')
          },
        },
        {
          path: '/teacher',
          name: 'teacher',
          components: {
            default: () => import('../views/teacher.vue')
          },
        },
        /** 名师详情 */
        {
          path: '/teacherdetails/:id',
          name: 'teacherdetails',
          components: {
            default: () => import('../views/teacherdetails.vue')
          },
        },
        {
          path: '/dyteam',
          name: 'dyteam',
          components: {
            default: () => import('../views/dyteam.vue')
          },
        },
        {
          path: '/dynamic',
          name: 'dynamic',
          components: {
            default: () => import('../views/dynamic.vue')
          },
        },
        {
          path: '/contactUs',
          name: 'contactUs',
          components: {
            default: () => import('../views/contactUs.vue')
          },
        }, {
          path: '/details/:id/:ctype',
          name: 'details',
          components: {
            default: () => import('../views/details.vue')
          },
        }
        , {
          path: '/honordetails/:id/:tag',
          name: 'honordetails',
          meta: {
            title: '影赛资讯',
          },
          components: {
            default: () => import('../views/honordetails.vue')
          },
        },
        {
          path: '/cmsDetail/:id',
          name: 'cmsDetail',
          meta: {
            title: '资讯详情',
          },
          components: {
            default: () => import('../views/cms_detail.vue')
          },
        },
        , {
          //影赛分类
          path: '/souitem/1',
          name: 'souitem',
          components: {
            default: () => import('../components/souitem.vue')
          },
        }
        , {
          // 采风分类
          path: '/souitem/2',
          name: 'souitem',
          components: {
            default: () => import('../components/souitem.vue')
          },
        }
        , {
          // 培训分类
          path: '/souitem/3',
          name: 'souitem',
          components: {
            default: () => import('../components/souitem.vue')
          },
        }
        , {
          path: '/gamedetails/:id/:ctype',
          name: 'gamedetails',
          components: {
            default: () => import('../views/gamedetails.vue')
          },
        }
        , {
          path: '/trainingdetails/:id/:ctype',
          name: 'trainingdetails',
          components: {
            default: () => import('../views/trainingdetails.vue')
          },
        }
        , {
          path: '/teacherdetails/:id',
          name: 'teacherdetails',
          components: {
            default: () => import('../views/teacherdetails.vue')
          },
        }
        , {
          path: '/shop',
          name: 'shop',
          components: {
            default: () => import('../views/shop.vue')
          },
        }
        , {
          path: '/shopDetail/:id',
          name: 'shopDetail',
          components: {
            default: () => import('../views/shopDetail.vue')
          },
        }
        , {
          path: '/usercenter',
          redirect: '/usercenter',
          components: {
            default: () => import('../components/usercenterLayout.vue')
          },
          children: [
            {
              path: '/usercenter',
              name: 'usercenter',
              components: {
                default: () => import('../views/usercenter.vue')
              },
            },
            {
              path: '/dycoinDetails',
              name: 'dycoinDetails',
              components: {
                default: () => import('../views/dycoinDetails.vue')
              },
            },
            {
              path: '/orderList',
              name: 'orderList',
              components: {
                default: () => import('../views/orderList.vue')
              },
            },
            {
              path: '/orderdetail/:out_trade_no',
              name: 'orderdetail',
              components: {
                default: () => import('../views/orderdetail.vue')
              },
            },
            {
              path: '/psCenter',
              name: 'psCenter',
              components: {
                default: () => import('../views/psCenter.vue')
              },
            },
            {
              path: '/psOrderDetail',
              name: 'psOrderDetail',
              components: {
                default: () => import('../views/psOrderDetail.vue')
              },
            },
            {
              path: '/film_upload/:id',
              name: 'film_upload',
              components: {
                default: () => import('../views/film_upload.vue')
              },
            },
            {
              path: '/images_upload/:id/:sku',
              name: 'images_upload',
              components: {
                default: () => import('../views/images_upload.vue')
              },
            },
            {
              path: '/uploadImgs/:id',
              name: 'uploadImgs',
              components: {
                default: () => import('../views/uploadImgs.vue')
              },
            },
            {
              path: '/account',
              name: 'account',
              components: {
                default: () => import('../views/account.vue')
              },
            },
            {
              path: '/accountSecy',
              name: 'accountSecy',
              components: {
                default: () => import('../views/account_safe.vue')
              },
            },
            {
              path: '/settingPswd',
              name: 'settingPswd',
              components: {
                default: () => import('../views/settingPswd.vue')
              },
            },
            {
              path: '/order',
              name: 'order',
              components: {
                default: () => import('../views/order.vue')
              },
            },
            {
              path: '/myEdu',
              name: 'myEdu',
              components: {
                default: () => import('../views/myEdu.vue')
              },
            },
            {
              path: '/myPreset',
              name: 'myPreset',
              components: {
                default: () => import('../views/myPreset.vue')
              },
            },
          ]
        },
        {
          path: '/pay/:order_type/:unique_no',
          name: 'pay',
          components: {
            default: () => import('../views/pay.vue')
          },
        },
        {
          path: '/payResult/:out_trade_no',
          name: 'payResult',
          components: {
            default: () => import('../views/payResult.vue')
          },
        },
        {
          path: '/vip',
          name: 'vip',
          components: {
            default: () => import('../views/vip.vue')
          },
        },
        {
          path: '/images_order/:unique_no',
          name: 'images_order',
          components: {
            default: () => import('../views/images_order.vue')
          },
        },
        {
          path: '/acr',
          name: 'acr',
          components: {
            default: () => import('../views/acr.vue')
          },
        },
        {
          path: '/videos',
          name: 'videos',
          components: {
            default: () => import('../views/videos.vue')
          },
        },
        {
          path: '/videoDetail',
          name: 'videoDetail',
          components: {
            default: () => import('../views/videoDetail.vue')
          },
        },
      ]
    },
    {
      path: '/lectureApp',
      name: 'lectureApp',
      components: {
        default: () => import('../views/lectureApp.vue')
      },
    },
  ]
})
router.beforeEach((to, from, next) => {
  //设置标题
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title;
  } else {
    window.document.title = '大扬影像';
  }
  let vuex_user = window.localStorage.getItem("vuex_user");
  //用户中心登录权限
  var checkRe = /^\/(usercenter|film\_upload)/i;
  for (let i = 0; i < to.matched.length; i++) {
    if (to.matched[i].path.match(checkRe)) {
      if (!vuex_user || vuex_user == 'null') {
        return next("/home");
      }
    }
  }

  next();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js